import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator(function* (_ref) {
    var {
      app,
      store
    } = _ref;
    app.router.beforeEach((to, from, next) => {
      store.dispatch('routeNavigation/updateCurrentRoute', to);
      store.dispatch('routeNavigation/updatePreviousRoute', from);
      next();
    });
  });

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();